(function () {
  'use strict';

  var ROOT = '[data-partner-apply]';
  var instances = new WeakMap();
  var nativeSubmit = HTMLFormElement.prototype.submit;

  function init(root) {
    var form = root.querySelector('form');
    if (!form || instances.has(form)) return;

    var messages = {};
    try {
      var node = root.querySelector('[data-partner-apply-i18n]');
      messages = JSON.parse(node ? node.textContent : '{}');
    } catch (error) {}

    var errorEl = root.querySelector('[data-partner-apply-error]');

    var requiredNames = [
      'contact[Name]',
      'contact[Last name]',
      'contact[Company name]',
      'contact[Country]',
      'contact[Phone]',
      'contact[email]',
      'contact[Primary business]'
    ];

    var groups = [
      {
        attr: 'data-partner-vehicle',
        hidden: '[data-partner-vehicles-value]',
        key: 'vehiclesRequired',
        fallback: 'Please select at least one equipment type.'
      },
      {
        attr: 'data-partner-heating',
        hidden: '[data-partner-heating-value]',
        key: 'heatingRequired',
        fallback: 'Please select at least one heating/AC experience option.',
        exclusiveLast: true
      },
      {
        attr: 'data-partner-store',
        hidden: '[data-partner-store-value]',
        key: 'storeRequired',
        fallback: 'Please select at least one store type option.',
        exclusiveLast: true
      },
      {
        attr: 'data-partner-service',
        hidden: '[data-partner-service-value]',
        key: 'servicesRequired',
        fallback: 'Please select at least one service option.'
      }
    ];

    function values(group) {
      return Array.from(
        root.querySelectorAll('[' + group.attr + ']:checked')
      ).map(function (input) {
        return input.value;
      });
    }

    function sync() {
      groups.forEach(function (group) {
        var selected = values(group);
        var hidden = root.querySelector(group.hidden);
        var first = root.querySelector('[' + group.attr + ']');

        if (hidden) hidden.value = selected.join(', ');

        // Hidden fields cannot enforce native required validation.
        // Attach the group's validity to its first visible checkbox.
        if (first) {
          first.setCustomValidity(
            selected.length
              ? ''
              : messages[group.key] || group.fallback
          );
        }
      });

      requiredNames.forEach(function (name) {
        var field = form.elements.namedItem(name);
        if (!field) return;

        field.required = true;
        field.setCustomValidity(
          String(field.value || '').trim()
            ? ''
            : messages.required || 'Please fill in all required fields.'
        );
      });
    }

    function showError(field, message) {
      var success = root.querySelector('[data-partner-apply-success]');
      if (success) success.hidden = true;

      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
        errorEl.setAttribute('role', 'alert');
      }

      if (field) {
        field.focus();
        field.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }

    function prepare() {
      sync();

      // Fail closed if expected fields or option groups are missing.
      var missingField = requiredNames.some(function (name) {
        return !form.elements.namedItem(name);
      });

      var missingGroup = groups.some(function (group) {
        return !root.querySelector('[' + group.attr + ']');
      });

      if (missingField || missingGroup) {
        showError(null, 'The form could not load correctly. Please refresh and try again.');
        return false;
      }

      var invalid = Array.from(form.elements).find(function (field) {
        return field.willValidate && !field.validity.valid;
      });

      if (invalid) {
        showError(invalid, invalid.validationMessage);
        return false;
      }

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      // Preserve the original contact field names and email body.
      var rows = [];

      Array.from(form.elements).forEach(function (field) {
        var match = /^contact\[(.+)\]$/.exec(field.name || '');
        if (!match || match[1] === 'body') return;
        if (
          (field.type === 'checkbox' || field.type === 'radio') &&
          !field.checked
        ) return;

        var value = String(field.value || '').trim();
        if (value) rows.push(match[1] + ': ' + value);
      });

      var body = root.querySelector('[data-partner-apply-body]');
      if (body) body.value = rows.join('\n');

      return true;
    }

    form.addEventListener('input', sync);

    form.addEventListener('change', function (event) {
      groups.forEach(function (group) {
        if (!group.exclusiveLast) return;

        var options = Array.from(
          root.querySelectorAll('[' + group.attr + ']')
        );

        if (options.indexOf(event.target) === -1) return;

        // In the current markup, the last option is "None".
        var none = options[options.length - 1];

        if (event.target.checked && event.target === none) {
          options.forEach(function (option) {
            if (option !== none) option.checked = false;
          });
        } else if (event.target.checked && none) {
          none.checked = false;
        }
      });

      sync();
    });

    // Recalculate checkbox validity after resetting the form.
    form.addEventListener('reset', function () {
      setTimeout(sync, 0);
    });

    // Guard calls made through this specific form instance.
    // Do not modify the global HTMLFormElement prototype.
    Object.defineProperty(form, 'submit', {
      configurable: true,
      writable: true,
      value: function () {
        if (prepare()) {
          return nativeSubmit.call(form);
        }
      }
    });

    instances.set(form, { prepare: prepare });
    sync();
  }

  function scan(container) {
    if (container instanceof Element && container.matches(ROOT)) {
      init(container);
    }

    if (container.querySelectorAll) {
      container.querySelectorAll(ROOT).forEach(init);
    }
  }

  function guard(event, form) {
    if (!(form instanceof HTMLFormElement)) return;

    var root = form.closest(ROOT);
    if (!root) return;

    init(root);
    var instance = instances.get(form);

    if (!instance || !instance.prepare()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  // Capture before listeners on the submit button or form.
  window.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest('[data-partner-apply-submit]');
    if (button) guard(event, button.form);
  }, true);

  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.isComposing) return;
    if (!(event.target instanceof Element)) return;

    if (
      event.target.matches(
        'input:not([type="checkbox"]):not([type="radio"])'
      )
    ) {
      guard(event, event.target.form);
    }
  }, true);

  window.addEventListener('submit', function (event) {
    guard(event, event.target);
  }, true);

  // Display errors when native validation blocks submission.
  window.addEventListener('invalid', function (event) {
    var field = event.target;
    if (!field.form || !field.form.closest(ROOT)) return;

    guard(event, field.form);
  }, true);

  window.addEventListener('pageshow', function () {
    scan(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
